import React from 'react';
import PropTypes from 'prop-types';
import BrainIcon from '../../../assets/images/companion/brain.svg';
import GameProgressBar from './GameProgressBar';
import phrasesType from '../../proptypes/phrases';

const IncompleteBrainGames = ({
  nextBrainGamePath,
  numberOfPlayedChallenges,
  numberOfRemainingChallenges,
  phrases: {
    companionSessions: {
      brainGames,
      brainGamesRemaining: {
        one: oneGameRemaining,
        other: multipleGamesRemaining,
      },
      playNextGame,
      playNow,
    },
  },
}) => {
  const gameCountLabel = numberOfRemainingChallenges === 1
    ? oneGameRemaining
    : multipleGamesRemaining.replace('%{count}', numberOfRemainingChallenges);

  return (
    <>
      <div className="icon-coloured">
        <BrainIcon />
      </div>
      <h2 className="h2 display-font text-center">{brainGames}</h2>
      {numberOfPlayedChallenges > 0 ? (
        <>
          <p className="text-center">{gameCountLabel}</p>
          <div className="mt-3 mb-4 text-center">
            <GameProgressBar
              numberOfPlayedChallenges={numberOfPlayedChallenges}
              numberOfRemainingChallenges={numberOfRemainingChallenges}
            />
          </div>
          <a href={nextBrainGamePath} role="button" className="btn btn-primary w-100">
            {playNextGame}
          </a>
        </>
      ) : (
        <a href={nextBrainGamePath} role="button" className="btn btn-primary w-100 mt-2">
          {playNow}
        </a>
      )}
    </>
  );
};

IncompleteBrainGames.propTypes = {
  nextBrainGamePath: PropTypes.string.isRequired,
  numberOfPlayedChallenges: PropTypes.number.isRequired,
  numberOfRemainingChallenges: PropTypes.number.isRequired,
  phrases: phrasesType.isRequired,
};

export default IncompleteBrainGames;
